/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Landing_Hero_Cta_NoteInputs */

const tr_landing_hero_cta_note = /** @type {(inputs: Landing_Hero_Cta_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} gün ücretsiz deneyin · Kredi kartı gerekmez · İstediğiniz zaman iptal edin`)
};

const en_landing_hero_cta_note = /** @type {(inputs: Landing_Hero_Cta_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days}-day free trial · No credit card required · Cancel anytime`)
};

const de_landing_hero_cta_note = /** @type {(inputs: Landing_Hero_Cta_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} Tage kostenlos testen · Keine Kreditkarte erforderlich · Jederzeit kündbar`)
};

const ru_landing_hero_cta_note = /** @type {(inputs: Landing_Hero_Cta_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} дней бесплатно · Кредитная карта не требуется · Отмена в любой момент`)
};

/**
* | output |
* | --- |
* | "{days}-day free trial · No credit card required · Cancel anytime" |
*
* @param {Landing_Hero_Cta_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_hero_cta_note = /** @type {((inputs: Landing_Hero_Cta_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Cta_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_cta_note(inputs)
	if (locale === "de") return de_landing_hero_cta_note(inputs)
	if (locale === "ru") return ru_landing_hero_cta_note(inputs)
	return tr_landing_hero_cta_note(inputs)
});